import { addDays } from "date-fns";
import { Dispatch } from "../../config/controller";
import { Atendimento, Paciente, Tratamento } from "../../config/data.types";
import { Model, StateProps } from "../../config/model";
import store from "../../store";
import { atendimentoController } from "./atendimento.controller";

export type { Atendimento, Tratamento } from "../../config/data.types";

export interface TratamentosGroup {
    descricao: string
    qt: number
    em_dia: Atendimento[]
    atrazados: Atendimento[]
}

export interface TratamentoGroupRow {
    descricao: string
    situacao: "Em Dia" | "Em Atraso"
    rows: Atendimento[]
}

export interface FiltroAtendimento {
    status:"em_dia"|"atrasado"|"todos",
    situacao:"ativo"|"inativo"|"todos", 
    periodo_em_dia:number,
    periodo_em_atraso:number
}


export interface AtendimentoState extends StateProps<Atendimento> {
    rowsTratamentosBySituacao: TratamentosGroup[]
    rowTratamentoGroup: TratamentoGroupRow
    showModalCadTratamento: boolean
    indexTratamento: number
    showFormFiltro: boolean
    filtro:FiltroAtendimento
}


export interface AtendimentoActions extends Dispatch<Atendimento> {
    novoAtendimento: () => any
    salvarAtendimento: (row: Atendimento) => any
    filterAtendimentos: (filter: FiltroAtendimento) => any
    handleRealizarTratamento: () => any
    handleCancelartratamento: () => any
    setRowTratamentoGroup: (row: TratamentoGroupRow) => any
    setShowModalCadTratamento: (set: boolean, index: number) => any
    corrigirDados: (atendimentos: Atendimento[]) => any
    setFiltro:(filtro:FiltroAtendimento) => any
    setShowFormFiltro:(show:boolean) => any
    getAtendimentosByPaciente:(id_paciente:string, procedimento_id:string, id_atendimento?:string) => any
}

const model = new Model<Atendimento, AtendimentoState>("atendimento");

export const initialValueTratamento: Tratamento = {
    procedimento: {} as any,
    obs: "",
    data_retorno: addDays(new Date(), 31).toISOString(),
    periodo_retorno: "31",
    data_tratamento: new Date().toISOString(),
}

export const initialValueAtendimento: Atendimento = {
    ...model.getInitialValue(),
    type: "atendimento",
    data: "",
    paciente: {} as Paciente,
    obs: "",
    situacao: "ativo",
    tratamento: initialValueTratamento,
}


export const initialValueAtendimentoState: AtendimentoState = {
    ...model.getInititalValueState(),
    row: initialValueAtendimento,
    rowsTratamentosBySituacao: [],
    rowTratamentoGroup: {} as TratamentoGroupRow,
    showModalCadTratamento: false,
    indexTratamento: -1,
    filtro: {
        situacao: "ativo",
        status: "todos",
        periodo_em_atraso: 30,
        periodo_em_dia: 30,
    },
    showFormFiltro: false,
}
